import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const LocalFonts = () => (
    <Global
        styles={`
            @font-face {
                font-family: 'Anton';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/anton-v25-latin_latin-ext-regular.woff2'
                )}) format('woff2');
            }
            @font-face {
                font-family: 'Anton-fallback';
                src: local(Impact);
                size-adjust: 93%;
                ascent-override: 117%;
                descent-override: 41%;
                line-gap-override: normal;
            }
            @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/inter-v13-latin_latin-ext-regular.woff2'
                )}) format('woff2');
            }
            @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/inter-v13-latin_latin-ext-500.woff2'
                )}) format('woff2');
            }
            @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-weight: 600;
                font-display: swap;
                src: url(${getAssetUrl(
                    'static/fonts/inter-v13-latin_latin-ext-600.woff2'
                )}) format('woff2');
            }
            @font-face {
                font-family: 'Inter-fallback';
                src: local(Arial);
                size-adjust: 105%;
                ascent-override: normal;
                descent-override: normal;
                line-gap-override: normal;
            }
        `}
    />
)

export {LocalFonts}
